// extracted by mini-css-extract-plugin
module.exports = {"number":"number-1eNOm","seat":"seat-14BTF","seat_occupied":"seat_occupied-1qs_Z","seat_confirmed":"seat_confirmed-2-bl2"};